import { useEffect } from 'react';
import { motion, AnimatePresence, useReducedMotion } from 'motion/react';

export default function Toast({ message, variant = 'info', onClose, duration = 3000 }) {
  const reduceMotion = useReducedMotion();

  useEffect(() => {
    if (!duration || !onClose) return;
    const timer = setTimeout(onClose, duration);
    return () => clearTimeout(timer);
  }, [duration, onClose]);

  const borderColor =
    variant === 'success'
      ? 'rgba(22,163,74,0.4)'
      : variant === 'danger'
      ? 'rgba(220,38,38,0.4)'
      : variant === 'warning'
      ? 'rgba(217,119,6,0.4)'
      : 'rgba(0,240,255,0.3)';

  return (
    <AnimatePresence>
      {message && (
        <motion.div
          initial={reduceMotion ? {} : { opacity: 0, y: -12 }}
          animate={reduceMotion ? {} : { opacity: 1, y: 0 }}
          exit={reduceMotion ? {} : { opacity: 0, y: -12 }}
          transition={{ duration: 0.18 }}
          style={{
            position: 'fixed',
            top: '1rem',
            right: '1rem',
            zIndex: 200,
            background: 'var(--bg-card)',
            border: `1px solid ${borderColor}`,
            borderRadius: 'var(--radius)',
            padding: '0.75rem 1rem',
            boxShadow: '0 8px 24px rgba(0,0,0,0.35)',
            minWidth: '240px',
            maxWidth: '400px',
          }}
        >
          <div style={{ fontSize: '0.9rem', fontWeight: 600 }}>{message}</div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
